import React, { useState, memo } from "react";
import {
  Box,
  Card,
  createStyles,
  Group,
  Menu,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { IconChevronDown, IconCreditCard } from "@tabler/icons-react";
import { formatCurrency } from "@/utils/common";

type FromAccountProps = {
  title?: string;
}

type SourceMock = {
  id: number;
  cardMask: string;
  sourceName: string;
  balance: number;
};

const MOCK_SOURCES: SourceMock[] = [
  {
    id: 1,
    cardMask: "666613112001",
    // VersionEn: tên doanh nghiệp trong dữ liệu giả — danh từ riêng, không dịch.
    sourceName: "Công ty cổ phần công nghệ Proton",
    balance: 10_988_909.98,
  },
  {
    id: 2,
    cardMask: "666613112001",
    sourceName: "Công ty cổ phần công nghệ Photon",
    balance: 20_988_909.98,
  },
  {
    id: 3,
    cardMask: "666613112001",
    sourceName: "Công ty cổ phần công nghệ Midway",
    balance: 30_988_909.0,
  },
];

const useStyles = createStyles(() => ({
  item: {
    "&[data-hovered]": {
      backgroundColor: "rgba(255,255,255,0.18)",
    },
  },
}));

const FromAccountVnd: React.FC<FromAccountProps> = ({ title }) => {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  const [selectedId, setSelectedId] = useState<number>(MOCK_SOURCES[0].id);
  const selected = MOCK_SOURCES.find((s) => s.id === selectedId)!;

  const handleChange = (id: number) => {
    setSelectedId(id);
    // nếu cần bắn ra ngoài thì gọi props.onChangeSourceLinkId(id) ở đây
  };

  return (
    <Card w="100%">
      <Card.Section mt="md">
        <Group
          position="apart"
          spacing={0}
          p="md"
          w="100%"
          style={{ borderRadius: 8 }}
          bg="linear-gradient(89.39deg, #0058A0 -1.09%, #2A81D0 104.44%)"
        >
          <Menu
            width="target"
            position="bottom"
            withinPortal
            classNames={classes}
          >
            {/* Header hiển thị tài khoản đang chọn */}
            <Menu.Target>
              <Group position="apart" w="100%" sx={{ cursor: "pointer" }}>
                <Group spacing="sm">
                  <Box
                    sx={{
                      background: "#FDFDFD",
                      padding: 8,
                      borderRadius: "50%",
                    }}
                  >
                    <IconCreditCard />
                  </Box>

                  <Stack spacing={2} c="white">
                    <Text fz={14} c="#fff">{selected.cardMask}</Text>
                    <Text fz="sm" fw={600} c="#fff">
                      {title} {selected.sourceName}
                    </Text>
                  </Stack>
                </Group>

                <Group spacing="xs" c="#fff">
                  <Text c="white" fw={500}>
                    {title} {formatCurrency(selected.balance)}
                  </Text>
                  <IconChevronDown
                    size="0.9rem"
                    stroke={1.5}
                    color={theme.white}
                  />
                </Group>
              </Group>
            </Menu.Target>

            {/* Dropdown list các tài khoản (giống ảnh) */}
            <Menu.Dropdown
              sx={{
                padding: 0,
                // background:
                //   "linear-gradient(89.39deg, #0058A0 -1.09%, #2A81D0 104.44%)",
                // color: "white",
              }}
            >
              {MOCK_SOURCES.map((source) => {
                const active = source.id === selectedId;
                return (
                  <Menu.Item
                    key={source.id}
                    onClick={() => handleChange(source.id)}
                    sx={{
                      paddingTop: 8,
                      paddingBottom: 8,
                      backgroundColor: active
                        ? "rgba(255,255,255,0.18)"
                        : "transparent",
                    }}
                  >
                    <Group position="apart" w="100%">
                      <Stack spacing={2}>
                        <Text fz={14}>{source.cardMask}</Text>
                        <Text fz="sm" fw={600}>
                          {title} {source.sourceName}
                        </Text>
                      </Stack>

                      <Text fz="sm" fw={500}>
                        {title} {formatCurrency(source.balance)}
                      </Text>
                    </Group>
                  </Menu.Item>
                );
              })}
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Card.Section>
    </Card>
  );
};

export default memo(FromAccountVnd);
